var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpanner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M487.5,391.3L281,184.7c4.1-13.7,6.3-28.4,6.3-42.4c0-37-15-73.7-41.3-100.6c0,0,0,0-0.1-0.1 C207.1,2,148.3-10.7,96.1,9.4c-6.4,2.5-11.1,8-12.5,14.7c-1.4,6.7,0.7,13.6,5.6,18.4L136,88.7l-10.9,32.4l-29.6,10.1l-46.8-48 c-4.7-4.9-11.6-7-18.3-5.7c-6.7,1.3-12.2,5.9-14.8,12.1C7.7,109,4,125.7,4,142.3c0,37,15,73.7,41.3,100.6 c26.2,26.9,62.8,42.3,100.4,42.3c10.8,0,21.4-1.2,31.7-3.6l210.1,210.1c13.9,13.5,32,20.2,50.1,20.2c18.3,0,36.5-6.9,50.2-20.7 C514.8,463.3,514.7,418.4,487.5,391.3z M459,463.1c-11.8,11.8-31.3,11.6-43.4,0L197.5,244.9c-3.8-3.8-9-5.9-14.3-5.9 c-2.1,0-4.3,0.3-6.4,1c-10,3.3-20.5,5-31.2,5c-26.8,0-52.9-11-71.5-30.1c-19-19.5-29.9-46-29.9-72.6c0-1.8,0.1-3.7,0.2-5.6 l31,31.8c5.4,5.6,13.6,7.5,20.9,5l51-17.5c5.9-2,10.6-6.7,12.6-12.6l18.1-53.7c2.5-7.3,0.6-15.4-4.9-20.8l-29-28.6 c27-0.5,53.4,9.7,72.9,29.5c19,19.5,29.9,46,29.9,72.5c0,13.4-2.8,27.6-7.9,40c-3.1,7.5-1.3,16.1,4.4,21.9L459,419.7 C470.8,431.5,470.7,451,459,463.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpanner);
export default __webpack_public_path__ + "static/media/spanner.aa9fdbe5c936aff04762ede7c3fbced9.svg";
export { ForwardRef as ReactComponent };